"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = setNotification;
exports.SET_NOTIFICATION = void 0;

var _uniqueID = _interopRequireDefault(require("../utils/uniqueID"));

var SET_NOTIFICATION = 'WEB_CHAT/SET_NOTIFICATION';
exports.SET_NOTIFICATION = SET_NOTIFICATION;

function setNotification(_ref) {
  var alt = _ref.alt,
      data = _ref.data,
      id = _ref.id,
      level = _ref.level,
      message = _ref.message;

  if (!id || typeof id !== 'string') {
    console.warn('botframework-webchat: The "id" argument passed to "setNotification" must be a string; defaulting to a random value.');
    id = (0, _uniqueID["default"])();
  }

  if (!level || typeof level !== 'string') {
    console.warn('botframework-webchat: The "level" argument passed to "setNotification" must be a string; defaulting to "info".');
    level = 'info';
  }

  return {
    type: SET_NOTIFICATION,
    payload: {
      alt: alt,
      data: data,
      id: id,
      level: level,
      message: message
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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